export default __webpack_public_path__ + "static/media/mavenLogo.99c64ad4.svg";